<script>
    import Data from './Data.svelte'
    export let archive;

    let items;
    let itemsFromInternet = window.punktsFromInternet || [];
    $: if (window.punkts === undefined){
        fetch(`https://paladin.kurs.finance/punkts/`)
            .then(r => r.json())
            .then(data => {
                items = data;
            });
    } else{
        items = window.punkts;
    }
       
</script>
  
{#if items}
<Data {items} {archive}/>
{:else}

<div class="loader loader-active">
    <div class="loader-inner line-scale-pulse-out-rapid">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    </div>
</div>
<div style="text-align: center;">
    Загрузка...
</div>
{/if}

{#if itemsFromInternet.length>0}
    <h2 class="kurs-h2">Курсы валют из других источников<b>*</b></h2>  
    <small><b>*</b>Пожалуйста, проверяйте достоверность курсов по телефонам обменных пунктов</small> 
    <Data items={itemsFromInternet} archive={false}/>
    <small>По материалам <a href="https://exchange.ninja" target="_blank">exchange.ninja</a></small> 
{/if}
<style>
    .kurs-h2 {
        font-size: 1.2rem;
        color:#D7A944;
    }
    small {
        color: #a8a8a8;
        font-size: 0.7rem;
        margin-top: -10px;
        display: block;
    }
    small a{
        color: #a8a8a8;
    }
</style>